import { pumaAPI } from "./api"

export const getConcepts = (): Promise<
    Api.PumaParsedPaginatedResponse<Models.Concept>
> => pumaAPI.getJSON("concepts", {})
